import * as consts from '../constants';
import initialState from './initialState';

export default function agentReducer(state = initialState.agentState, action) {
    switch (action.type) {
        case consts.ACTONS.LOAD_AGENTS_SUCCESS:
            return action.pagingModel;
        case consts.ACTONS.LOAD_AGENTS_FAILED:
            return initialState.agentState;
        default:
            return state;
    }
}
